import * as z from 'zod/v4';

import { apiErrorSchema } from '../error/entry.js';
import { drawForecastSchema } from './drawForecast.js';

export const drawForecastResponseSchema = z
  .object({
    forecastResult: drawForecastSchema,
  })
  .transform(({ forecastResult }) => ({ data: forecastResult }));

export const drawForecastApiResponse = {
  parse: (data: unknown) => z.union([drawForecastResponseSchema, apiErrorSchema]).parse(data),
} as const;
